import { attr, belongsTo } from '@ember-data/model';
import ShModel from './sh-model';

const ShInvoiceTransaction = ShModel.extend({
  amount: attr('number'),
  createdAt: attr('date'),
  processor: attr('string'),
  processorAccountId: attr('string'),
  processorTransactionId: attr('string'),
  updatedAt: attr('date'),

  //relationships
  related: belongsTo('shModel', {
    async: false,
    polymorphic: true,
  }),
  shInvoice: belongsTo('shInvoice', { async: false }),
});

export default ShInvoiceTransaction;
